import {
  Box3,
  Camera,
  Object3D,
  OrthographicCamera,
  PerspectiveCamera,
  Sphere,
  Vector3,
} from "three";
import { CameraInterface } from "../Engine";

export function fitObjectToCamerInterface(
  object: Object3D | { center: Vector3; radius: number },
  camera: CameraInterface
) {
  return fitObjectToCamera(object, camera.instance);
}

export function fitObjectToCamera(
  object: Object3D | { center: Vector3; radius: number },
  camera: Camera | PerspectiveCamera | OrthographicCamera | CameraInterface
) {
  if (camera instanceof PerspectiveCamera) {
    return fitObjectToPersCamera(object, camera);
  } else if (camera instanceof OrthographicCamera) {
    return fitObjectToOrthoCamera(object, camera);
  }

  return { position: new Vector3(), target: new Vector3() };
}

export function fitObjectToPersCamera(
  object: Object3D | { center: Vector3; radius: number },
  camera: PerspectiveCamera
) {
  let center = new Vector3();
  let radius = 1;
  if (object instanceof Object3D) {
    const box = new Box3().setFromObject(object, true);
    const sphere = box.getBoundingSphere(new Sphere());
    center = sphere.center;
    radius = sphere.radius;
  } else {
    center = object.center;
    radius = object.radius;
  }

  let fov = camera.aspect * camera!.fov * (Math.PI / 180) * 1.0;
  let distance = radius / Math.sin(fov * 0.5);

  const direction = new Vector3();
  camera.getWorldDirection(direction).multiplyScalar(-distance);

  let newPosition = center.clone().add(direction);

  //camera.position.copy(newPosition);
  //camera.lookAt(center);
  //camera.updateProjectionMatrix();

  return { position: newPosition, target: center, zoom: fov };
}

export function fitObjectToOrthoCamera(
  object: Object3D | { center: Vector3; radius: number },
  camera: OrthographicCamera
) {
  let center = new Vector3();
  let radius = 1;
  if (object instanceof Object3D) {
    const box = new Box3().setFromObject(object, true);
    const sphere = box.getBoundingSphere(new Sphere());
    center = sphere.center;
    radius = sphere.radius;
  } else {
    center = object.center;
    radius = object.radius;
  }

  let aspect = camera.right / camera.top;
  let newZoom = (aspect < 1.0 ? camera.right : camera.top) / radius;
  camera.zoom = newZoom;

  camera.position.copy(center).add(new Vector3(0, 10, 0));
  camera.updateProjectionMatrix();

  return { position: camera.position.clone(), target: center, zoom: newZoom };
}
